export default function PHP_zip_entry_open() {
  return (
    <div>
      <h1>PHP_zip_entry_open</h1>
    </div>
  );
}
